import Head from "next/head";
import { SITE_NAME, DEFAULT_META_DESCRIPTION } from "../lib/constants";

const Meta = ({ title, desc, image, author, publishedTime }) => {
  const fullTitle = title && title !== SITE_NAME ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const description = desc || DEFAULT_META_DESCRIPTION;
  return (
    <div>
      <Head>
        <title key="title">{fullTitle}</title>
        <link rel="icon" href="/favicon.ico" />
        <meta name="description" content={description} key="description" />
        <meta property="og:title" content={fullTitle} key="og:title" />
        <meta property="og:description" content={description} key="og:description" />
        <meta property="og:site_name" content={SITE_NAME} key="og:site_name" />
        {author && <meta name="author" content={author} />}
        {publishedTime && (
          <meta
            name="publish_date"
            property="og:publish_date"
            content={publishedTime}
          />
        )}
        {image && <meta property="og:image" content={image} />}
      </Head>
    </div>
  );
};

export default Meta;
